import React from 'react';
import TabContainer from '../../components/TabContainer';
// Pasife alındı 2026-05-01: Karkas parçalama askıya alındı (paketli ürün satın alımına geçiş)
// Karkas Parçalama sayfası (KarkasAnalizPage) 2026-06 itibarıyla tamamen kaldırıldı.
import UretimKaydiPage from '../uretim/UretimKaydiPage';
import UretimOzetPage from '../uretim/UretimOzetPage';
import SatisUrunOzetPage from '../uretim/SatisUrunOzetPage';


const UretimPage = () => {
  const tabs = [
    // Pasife alındı 2026-05-01 (Karkas Parçalama sekmesi 2026-06'da tamamen kaldırıldı):
    { id: 'uretim-kaydi', label: 'Üretim Kaydı', icon: '🏭', component: <UretimKaydiPage /> },
    { id: 'uretim-ozet', label: 'Üretim Özeti', icon: '📊', component: <UretimOzetPage /> },
     { id: 'sevk-edilen-urunler', label: 'Sevk Edilen Ürünler', icon: '🚚', component: <SatisUrunOzetPage /> },
  ];
  return <TabContainer title="Üretim" tabs={tabs} defaultTab="uretim-kaydi" />;
};

export default UretimPage;
